import ApiConnector from "@/repository/connector";

class Fcm {
  addFCMToken = async ({ token }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.post(`/v1/fcm-tokens/`, { token });
    result.value = response.data;
    result.error = response.detail
    return result;
  };
}

export default new Fcm();
